import {RouteConfig} from 'vue-router'
import {MenuItem} from '@/store/types';

export function routes (): RouteConfig[] {
    return [
        {
            name: 'guides.categories',
            path: '/soporte/guias/categorias',
            component: () => import('@/modules/support/components/Guide/CategoryMasterDetail.vue'),
            meta: {
                toolbarTitle: 'Categorías de soporte',
                authRequired: true,
                vuex: {
                    loadModules: ['support'],
                },
            },
        },
        {
            name: 'guides.guideList',
            path: '/soporte/guias/lista-de-guias',
            component: () => import('@/modules/support/components/Guide/GuideList.vue'),
            meta: {
                toolbarTitle: 'Guías de soporte',
                authRequired: true,
                vuex: {
                    loadModules: ['support'],
                },
            },
        },
        {
            name: 'guides.guideDetail',
            path: '/soporte/guias/editar-guia/:id',
            component: () => import('@/modules/support/components/Guide/GuideDetail.vue'),
            meta: {
                toolbarTitle: 'Ver/editar guía de soporte',
                authRequired: true,
                vuex: {
                    loadModules: ['support'],
                },
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Soporte al usuario',
            icon: 'mdi-face-agent',
            module: 'shipping',
            requireAuthorization: true,
            permission: '@/support/admin_access',
            children: [
                {
                    title: 'Categorías de soporte',
                    icon: 'mdi-label-multiple-outline',
                    routeName: 'guides.categories',
                    requireAuthorization: true,
                    permission: '@/support/guides/categories/admin_access',
                },
                {
                    title: 'Guías de soporte',
                    icon: 'mdi-message-question-outline',
                    routeName: 'guides.guideList',
                    requireAuthorization: true,
                    permission: '@/support/guides/categories/admin_access',
                },
            ],
        },
    ]
}
